<template>
  <div class="courses -helvetica-">
    <div class="important-button-wrap">
      <UiButton
        class="important-button -telegram- -mobile- -min-"
        v-if="showTelegram"
        to="/questionnaire/telegram"
      >
        <div class="important-button__content">
          <Icon icon="telegram" />
          <span>Подключиться к Telegram боту</span>
        </div>
      </UiButton>
    </div>
    <template v-if="courseFolders.length">
      <div class="courses__search">
        <Input
          v-if="$permissionsCreate === 2 && $permissionsRead"
          @input="setFilterQuery"
          type="text"
          :error="false"
          placeholder="Поиск по папкам"
        >
          <template #leftIcon>
            <SearchIcon />
          </template>
        </Input>
      </div>
      <div class="courses-cards position-relative">
        <div class="courses-cards__list">
          <template v-if="$permissionsCreate === 2 && $permissionsRead">
            <div class="courses-card courses-card-create">
              <Icon icon="educational" class="courses-card-create__icon"/>
              <UiButton @click="openNewFolderAside">
                Создать папку
              </UiButton>
            </div>
          </template>
          <Folder
            v-for="folder in filteredCourseList" :key="folder.id"
            :folder="folder"
          />
        </div>
      </div>
    </template>
    <template v-else-if="gettingFolders">
      <EmptyFolder />
    </template>
    <div v-else class="courses-card justify-center align-center -not-data-">
      <Icon icon="educational" class="width-60px margin-height__20" />
      <div class="courses-card-create__description text-center">
        Вы еще не приобрели курс
      </div>
    </div>
    <Aside
      v-if="asideIsOpen({name: asideName})"
      :name="asideName"
    >
      <template v-slot="{ asideObject, removeAside }">
        <FolderAside
          :asideObject="asideObject"
          @removeAside="removeAside"
        />
      </template>
    </Aside>
    <SuccessFacultyModal />
  </div>
</template>

<script>
import { debounce } from 'lodash';
import Folder from './layouts/Folder';
import FolderAside from './layouts/FolderAside';
import EmptyFolder from './Folder/EmptyFolder';
import SearchIcon from '@/components/Icons/SearchIcon';
import Input from '@/components/UiKit/v2/Input';

import SuccessFacultyModal from './components/SuccessFacultyModal';

import { mapState, mapActions } from 'vuex';
import asideMixin from '@/mixins/asideMixin';

export default {
  components: {
    Folder,
    FolderAside,
    EmptyFolder,
    SuccessFacultyModal,
    SearchIcon,
    Input
  },
  mixins: [asideMixin],
  data() {
    return {
      filterQuery: ''
    }
  },
  computed: {
    ...mapState('courses', {
      courseFolders: s => s.data.courseFolders,
      gettingFolders: s => s.meta.gettingFolders
    }),
    ...mapState('auth', {
      storeUser: s => s.data.user,
      $permissions: s => s.data.user.permissions.folderModuleAdmin,
      franchGameFolderId: s => s.data.user.franchGameFolderId
    }),
    ...mapState('coursesFolder', {
      asideName: s => s.data.asideName,
      canSave: s => s.aside.meta.canSave,
      isOpen: s => s.aside.meta.isOpen
    }),
    ...mapState('coursesCourse', {
      isErrorCourses: s => s.meta.isErrorCourses
    }),
    filteredCourseList() {
      let result
      if(this.filterQuery === '') {
        return this.courseFolders
      }
      result = this.courseFolders.filter(item => {
        return item.name.toLowerCase().includes(this.filterQuery.toLowerCase())
      })
      return result
    },
    showTelegram() {
      return (
        this.storeUser.needTelegram && !this.storeUser.redirectToQuestionnaire
      );
    }
  },
  created() {
    this.getFolders();
    this.setFilterQueryDebounced = debounce(event => this.filterQuery = event, 300);
  },
  beforeDestroy() {
    this.setFilterQueryDebounced.cancel();
  },
  mounted() {
    if (this.$route.query.message) {
      this.$store.dispatch('ajax/addMessage', {
        type: 'error',
        message: this.$route.query.message
      });
    }
  },
  methods: {
    ...mapActions('courses', {
      getFolders: 'getFolders'
    }),
    setFilterQueryDebounced() {},
    setFilterQuery(event) {
      this.setFilterQueryDebounced(event)
    },
    openNewFolderAside() {
      this.$store.dispatch('asides/addAside', {
        data: {
          name: this.asideName,
          title: 'Создайте новую папку',
          subtitle: 'После создания вы перейдете к созданию курса',
          folder: {}
        },
        meta: {
          hasChanges: false
        }
      });
    }
  }
};
</script>
